import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import DocsExample from '@/components/DocsExample'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import hideBtnActionPlugin from './plugins/hideBtnActionPlugin.js'

const vuetify = createVuetify({
  components,
  directives,
})

const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(VueSweetalert2)
app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('DocsExample', DocsExample)
app.use(vuetify).mount('#app')

const user = JSON.parse(localStorage.getItem('user'))
if (user?.role != 'super_admin' && !user?.can_actions) {
  app.use(hideBtnActionPlugin, {
    selector: '.btnActionPermission',
    debounce: 60,
  })
}
